import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { IconComponent, IconName, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-app-shell-topbar-button',
  styleUrl: './tellent-app-shell-topbar-button.component.less',
  template: `
    @let isActiveVal = isActive();
    @let iconNameActiveVal = iconNameActive();
    @let iconNameVal = iconName();

    @let icon = isActiveVal ? (iconNameActiveVal ?? iconNameVal) : iconNameVal;

    <div
      class="inner"
      [class.active]="isActiveVal"
      rtTooltip
      [rtTooltipTemplate]="tooltipTemplate"
      [rtTooltipEnabled]="isTooltipEnabled()"
    >
      <rt-icon [size]="'medium'" [name]="icon!" />

      <ng-template #tooltipTemplate>
        <span>
          <strong>
            {{ label() }}
          </strong>
        </span>
      </ng-template>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, RtTooltip],
})
export class TellentAppShellTopbarButtonComponent {
  public iconName = input<IconName>();
  public label = input<string>();
  public iconNameActive = input<IconName>();
  public isActive = input<boolean>(false);

  public isTooltipEnabled = computed(() => {
    const label = this.label();
    return typeof label === 'string' && label.trim() !== '';
  });
}
